import React, { useEffect, useState } from 'react';
import axios from 'axios';
import MainJobsCard from './MainJobsCard';

const MainJobs = () => {
  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const itemsPerPage = 4;

  useEffect(() => {
    const fetchUsers = async () => {
      let activePosts = [];
      let activeOtherPosts = [];
      let activeFastPosts = [];
  
      try {
        const response = await axios.get('https://kariyer.biyomed.net/api/posts/getAllPosts');
        if (response.data.posts) {
          activePosts = response.data.posts.filter(post => post.job_status === 1);
        }
      } catch (error) {
        console.error('Error fetching getAllPosts:', error);
      }
  
      try {
        const res = await axios.get('https://kariyer.biyomed.net/api/admin/getAllOtherPosts', {
          params: { all: 'true', filterStatus: 1 }
        });
        if (res.data.job_listings) {
          activeOtherPosts = res.data.job_listings;
        }
      } catch (error) {
        console.error('Error fetching getAllOtherPosts:', error);
      }
            try {
        const res2 = await axios.get('https://kariyer.biyomed.net/api/posts/get-fast-post');
        
        if (res2.data.posts) {
          activeFastPosts = res2.data.posts.filter(post => post.job_status !== 0);
        }
      } catch (error) {
        console.error('Error fetching getAllOtherPosts:', error);
      }

      // Combine the two arrays and sort them by created_at date in descending order
      const allPosts = [...activePosts, ...activeOtherPosts, ...activeFastPosts];
      allPosts.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)); // Sort by latest date

      setPosts(allPosts);
    };
  
    fetchUsers();
  }, []);

  const handleChange = (newPage) => {
    setPage(newPage);
  };

  const startIndex = (page - 1) * itemsPerPage;
  const selectedPosts = posts.slice(startIndex, startIndex + itemsPerPage);
  const totalPages = Math.ceil(posts.length / itemsPerPage);

  return (
    <div style={{ flexDirection: 'column', minHeight: '100vh', marginBottom:'-200px' }}>
      <div style={{ textAlign: 'center', padding: '20px', flexGrow: 1 }}>
        {selectedPosts.map((post, index) => (
          <MainJobsCard key={index} post={post} />
        ))}
      </div>
      <div className="video_nav_img_wrapper" style={{ marginTop: 'auto', textAlign: 'center', padding: '20px' }}>
        <div className="video_nav_img">
          <ul style={{ listStyle: 'none', display: 'inline-flex', padding: 0 }}>
            {page > 1 && (
              <li style={{ margin: '5px', marginBottom: '50px' }}>
                <a
                  href='/'
                  className="button secondary url owl_nav"
                  onClick={(e) => { e.preventDefault(); handleChange(page - 1); }}
                  style={{ textDecoration: 'none', background: 'gray', color: 'white', borderRadius: '5px' }}
                >
                  &lt;
                </a>
              </li>
            )}
            {[1, 2, 3].map((i) => (
              i <= totalPages && (
                <li key={i} style={{ margin: '5px', marginBottom: '50px' }}>
                  <a
                    href='/'
                    className={`button secondary url owl_nav ${page === i ? 'active' : ''}`}
                    onClick={(e) => { e.preventDefault(); handleChange(i); }}
                    style={{ textDecoration: 'none', background: page === i ? 'blue' : 'gray', color: 'white', borderRadius: '5px' }}
                  >
                    {i}
                  </a>
                </li>
              )
            ))}
            {page > 3 && page < totalPages+1 && (
              <>
                <li style={{ margin: '5px', marginBottom: '50px' }}>
                  <a
                    href='/'
                    className="button secondary url owl_nav"
                    onClick={(e) => e.preventDefault()}
                    style={{ textDecoration: 'none', background: 'gray', color: 'white', borderRadius: '5px' }}
                  >
                    ...
                  </a>
                </li>
                <li style={{ margin: '5px', marginBottom: '50px' }}>
                  <a
                    href='/'
                    className="button secondary url owl_nav active"
                    onClick={(e) => { e.preventDefault(); handleChange(page); }}
                    style={{ textDecoration: 'none', color: 'white', borderRadius: '5px', backgroundColor:'blue' }}
                  >
                    {page}
                  </a>
                </li>
              </>
            )}
            {page < totalPages && (
              <li style={{ margin: '5px', marginBottom: '50px' }}>
                <a
                  href='/'
                  className="button secondary url owl_nav"
                  onClick={(e) => { e.preventDefault(); handleChange(page + 1); }}
                  style={{ textDecoration: 'none', background: 'gray', color: 'white', borderRadius: '5px' }}
                >
                  &gt;
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default MainJobs;
